import type { UpdateUserProfileRequest, UserProfile } from "@/shared/types/profile";
import { apiFetch } from "@/apis/http/apiFetch";

export async function fetchCurrentUser(): Promise<UserProfile> {
  const res = await apiFetch("/api/v1/me");
  return res.json() as Promise<UserProfile>;
}

export async function updateCurrentUser(body: UpdateUserProfileRequest): Promise<UserProfile> {
  const res = await apiFetch("/api/v1/me", {
    method: "PATCH",
    body: JSON.stringify(body),
  });

  return res.json() as Promise<UserProfile>;
}
